import { ChangeDetectionStrategy, Component, ElementRef, TemplateRef, computed, inject, input } from '@angular/core';
import { BigIcon, IconBigBoldSchliessen, IconComponent } from '@big-direkt/utils/icons';
import { BreakpointService } from '@big-direkt/utils/shared';
import { PopoverService } from '../../services/popover.service';
import { NavType, SidenavService } from '../../services/sidenav.service';
import { NavMainMobileComponent } from '../nav-main-mobile/nav-main-mobile.component';

@Component({
    selector: 'big-nav-mobile-icon-button',
    templateUrl: './nav-mobile-icon-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, NavMainMobileComponent],
})
export class NavMobileIconButtonComponent {
    private readonly sidenavService = inject(SidenavService);
    private readonly breakpointService = inject(BreakpointService);
    private readonly popoverService = inject(PopoverService);
    public readonly iconClose = IconBigBoldSchliessen;
    private readonly isTablet = this.breakpointService.isTablet;

    public readonly key = input<string>();
    public readonly navType = input.required<NavType>();
    public readonly label = input.required<string>();
    public readonly closeLabel = input.required<string>();
    public readonly icon = input<BigIcon>();
    public readonly customLoggedInContent = input<boolean>(false);

    public readonly isOpen = computed(() => this.sidenavService.currentSidenav() === this.navType());
    public readonly isOtherOpen = computed(() => !!this.sidenavService.currentSidenav() && this.sidenavService.currentSidenav() !== this.navType());

    public toggleNav(origin: HTMLElement, content: TemplateRef<ElementRef>): void {
        if (this.isTablet()) {
            this.togglePopupNav(origin, content);
        } else {
            this.toggleMobileNav();
        }
    }

    private togglePopupNav(origin: HTMLElement, content: TemplateRef<ElementRef>): void {
        this.popoverService.open(content, origin);
    }

    private toggleMobileNav(): void {
        if (this.sidenavService.currentSidenav() !== this.navType()) {
            this.sidenavService.openSidenav(this.navType());
        } else {
            this.sidenavService.closeSidenav();
        }
    }
}
